import { CopyToClipboardButton } from '@dixa/lib-shared-habla';
import { Fragment, ReactNode } from 'react';

import styles from './summaryItems.module.scss';

export type SummaryItem = {
  /** Stable key for the segment. */
  readonly key: string;
  /** Rendered content (text, or a link for e.g. a tracking URL). Empty/absent segments are dropped. */
  readonly content?: ReactNode;
  /** When set, renders a copy-to-clipboard button next to the segment. */
  readonly copyText?: string;
};

const hasContent = (item: SummaryItem): boolean =>
  item.content !== undefined && item.content !== null && item.content !== '';

type SummaryItemsProps = {
  readonly items: readonly SummaryItem[];
};

/**
 * An at-a-glance summary line for an activity card: segments joined by `·`,
 * each optionally with an inline copy button (e.g. order/fulfillment ids). Copy
 * clicks stopPropagation so they don't also toggle the card.
 */
export const SummaryItems = ({
  items,
}: SummaryItemsProps): JSX.Element | null => {
  const shown = items.filter(hasContent);
  if (!shown.length) {
    return null;
  }

  return (
    <span className={styles.items}>
      {shown.map((item, index) => (
        <Fragment key={item.key}>
          {index > 0 && <span className={styles.separator}>·</span>}
          <span className={styles.item}>
            {item.content}
            {item.copyText && (
              <CopyToClipboardButton
                textToCopy={item.copyText}
                buttonProps={{ icon: 'copy', variant: 'tertiary' }}
                // Stop the click on the button from also toggling the card.
                onClick={(event) => event.stopPropagation()}
              />
            )}
          </span>
        </Fragment>
      ))}
    </span>
  );
};
